import { useEffect } from "react";
import { useTabs } from "@/context/tabs/TabsContext";
import type { Widgets } from "@/context/tabs/types";
import { WIDGETS_WITH_TICKERS_LIST } from "@/shared/constants/common";
import type { ViewId } from "@/shared/types/common";

export function useUpdateTickerForLinkedWidgets(mosaicState: Widgets) {
	const { setWidgetState } = useTabs();

	useEffect(() => {
		for (const id in mosaicState) {
			const group = mosaicState[id];

			if (group?.color) {
				const isListWidget = WIDGETS_WITH_TICKERS_LIST.some((el: string) =>
					id.startsWith(el),
				);
				const isNewsWidget = id.startsWith("News");

				const groupTicker = Object.entries(mosaicState).find(
					([key, item]) =>
						item?.color === group.color &&
						item?.ticker !== undefined &&
						isListWidget ===
							WIDGETS_WITH_TICKERS_LIST.some((el: string) =>
								key.startsWith(el),
							),
				)?.[1]?.ticker;

				if (
					groupTicker &&
					groupTicker !== mosaicState[id]?.ticker &&
					!isListWidget &&
					!(isNewsWidget && mosaicState[id]?.ticker === "")
				) {
					setWidgetState(id as ViewId, {
						...mosaicState[id],
						ticker: groupTicker,
					});
				}
			}
		}
	}, [mosaicState, setWidgetState]);
}
